import { LoaderFunctionArgs } from 'react-router-dom';
import { decodeState } from './urlState';

export const appLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const encoded = url.searchParams.get('s');

  if (encoded) {
    return decodeState(encoded);
  }

  return [];
};
